const e = Object.freeze({
  key: Symbol("TABLE_INJECTION_KEY")
});
export {
  e as T
};
//# sourceMappingURL=Table.keys-LHQf6FEH.js.map
